import React from "react";
import PropTypes from "prop-types";
import { Slice } from "gatsby";
import { usePageContext } from "../../context/PageContext";
import { TableConnector } from "../TableConnector";
import { FormAssemblyConnector } from "../../components/FormAssembly";
import { SearchBoxConnector } from "../../connectors/SearchBoxConnector";
import { AnchorTagConnector } from "../../components/Anchor/AnchorTagConnector";
import { EmailAcquisitionConnector } from "../EmailAcquisitionConnector";
import { Section } from "../../components/Section";

import * as styles from "./componentBlockConnector.module.scss";

const ComponentBlockConnector = ({ data }) => {
	const content = data?.configuration && JSON.parse(data?.configuration?.internal?.content);
	const { lang } = usePageContext();

	switch (data?.componentType) {
		case "table":
			return <TableConnector data={content} language={lang} />;
		case "form-assembly":
			return <FormAssemblyConnector data={content} />;
		case "search-box":
			return <SearchBoxConnector data={content} language={lang} type={data.type} />;
		case "anchor-tag":
			return <AnchorTagConnector data={content} />;
		case "signup-form-assembly":
			return <EmailAcquisitionConnector data={content} language={lang} />;
		case "hotel-chain-carousel":
			return (
				<Section
					title={content?.title}
					titleAs="h2"
					titleAlignment="left"
					className={styles.title}
					classNames={styles.sectionContainer}
					titleSize="large">
					<Slice alias="hotelChainsCarousel" allowEmpty="true" />
				</Section>
			);
		default:
			return null;
	}
};

ComponentBlockConnector.propTypes = {
	data: PropTypes.object.isRequired,
};

export { ComponentBlockConnector };
